import { createReducers, createActions, request } from '../../../utils/';
import { combineReducers } from 'redux';
import Urls from '../../../../config/index';
import { message } from 'antd';

const { MonitorUrl } = Urls;

const path = name => `app/pages/discardList/${name}`;
const models = {
    list: {
        data: [],
        handlers: {
            get(state, action) {
                return action.payload;
            },
            add(state, action) {
                return [...action.payload, ...state];
            },
            del(state, action) {
                return state.filter(item => item._id !== action.payload);
            },
            update(state, action) {
                return state.map(item => (item._id === action.payload._id ? action.payload : item));
            },
        },
    },
    selectedContent: {
        data: [],
        handlers: {
            getSele(state, action) {
                return action.payload;
            },
        },
    },
    listAll: {
        data: [],
        handlers: {
            getAll(state, action) {
                return action.payload;
            },
        },
    },
    transferData: {
        data: {
            selectedRowKeys: [],
        },
        handlers: {
            getTransferData(state, action) {
                return { ...state, ...action.payload };
            },
        },
    },
    pagination: {
        data: {
            current: 1,
            total: 0,
            pageSize: 10,
        },
        handlers: {
            changePagination(state, action) {
                return {
                    ...state,
                    ...action.payload,
                };
            },
        },
    },
    searchValues: {
        data: {},
        handlers: {
            changeSearchValues(state, action) {
                return action.payload;
            },
        },
    },
    uiStatus: {
        data: {
            isLoading: false,
            isUpdateShow: false,
            isSendCommend: false,
        },
        handlers: {
            changeUiStatus(state, action) {
                return {
                    ...state,
                    ...action.payload,
                };
            },
        },
    },
    currentSelectId: {
        data: '',
        handlers: {
            changeCurrentSelectId(state, action) {
                return action.payload;
            },
        },
    },
};

export const actions = createActions(models, path);

export default combineReducers(createReducers(models, path));

const formatGetParams = getState => {
    const state = getState().agentManage;
    const searchValue = state.searchValues || {};

    const params = {
        ...searchValue,
        page: state.pagination.current,
        pageSize: state.pagination.pageSize,
    };
    return params;
};

/**
 * 获取订单列表数据
 */
export const asyncGet = () => {
    return async (dispatch, getState) => {
        try {
            dispatch(
                actions.changeUiStatus({
                    isLoading: true,
                }),
            );
            // 下面的请求和结果返回需要根据接口来实现
            let response = await request(MonitorUrl.getAllProxyPoolLength, 'GET');
            dispatch(actions.get(response));
        } catch (e) {
            throw e;
        } finally {
            dispatch(
                actions.changeUiStatus({
                    isLoading: false,
                }),
            );
        }
    };
};
export const delProxyKey = keyName => {
    return async (dispatch,getState) =>{
        try {
            dispatch(actions.changeUiStatus({ isLoading: true }));
            await request(MonitorUrl.delProxyKey + '?key=' + keyName, 'GET');
            message.success('删除成功');
            dispatch(actions.changeUiStatus({ isUpdateShow: false }));
        } catch (e) {
            throw e;
        } finally {
            dispatch(actions.changeUiStatus({ isLoading: false }));
        }
    };
};
export const asyncUpdate = contents => {
    return async (dispatch, getState) => {
        try {
            dispatch(actions.changeUiStatus({ isLoading: true }));
            // 下面的请求和结果返回需要根据接口来实现
            await request(scriptUrl.setScript, 'POST', contents);
            message.success('修改成功');
            dispatch(actions.changeUiStatus({ isUpdateShow: false }));
        } catch (e) {
            throw e;
        } finally {
            dispatch(actions.changeUiStatus({ isLoading: false }));
        }
    };
};

// 添加脚本
export const asyncAdd = contents => {
    return async (dispatch, getState) => {
        try {
            dispatch(actions.changeUiStatus({ isLoading: true }));
            // 下面的请求和结果返回需要根据接口来实现
            await request(scriptUrl.addScript, 'POST', contents);
            message.success('添加成功');
            dispatch(actions.changeUiStatus({ isUpdateShow: false }));
        } catch (e) {
            throw e;
        } finally {
            dispatch(actions.changeUiStatus({ isLoading: false }));
        }
    };
};

// 删除用户
export const delect = record => {
    return async (dispatch, getState) => {
        try {
            dispatch(actions.changeUiStatus({ isLoading: true }));
            // 下面的请求和结果返回需要根据接口来实现
            await request(scriptUrl.del, 'POST', record);
            message.success('删除成功');
            dispatch(actions.changeUiStatus({ isUpdateShow: false }));
        } catch (e) {
            throw e;
        } finally {
            dispatch(actions.changeUiStatus({ isLoading: false }));
        }
    };
};

// 删除用户组
export const delectAll = ids => {
    return async (dispatch, getState) => {
        try {
            dispatch(
                actions.changeUiStatus({
                    isLoading: true,
                }),
            );
            // 下面的请求和结果返回需要根据接口来实现
            await request(scriptUrl.delBatch, 'POST', ids);
            message.success('删除成功');
            dispatch(actions.changeUiStatus({ isUpdateShow: false }));
        } catch (e) {
            throw e;
        } finally {
            dispatch(
                actions.changeUiStatus({
                    isLoading: false,
                }),
            );
        }
    };
};




// WEBPACK FOOTER //
// ./pages/monitor/agent/reducers.js